
import Hero from "@/components/Hero";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { Check, ArrowRight } from "lucide-react";

const Hypnotherapy = () => {
  return (
    <div className="fade-in">
      <Hero 
        title="Hüpnoteraapia"
        subtitle="Vaata sügavamale oma alateadvusse ja vabasta piiravad mõttemustrid."
        bgColor="bg-gradient-to-r from-kaija-sage to-kaija-light"
      />
      
      <section className="section-padding bg-white">
        <div className="container-custom">
          <div className="max-w-3xl mx-auto">
            <div className="w-20 h-1 bg-kaija-slate rounded-full mx-auto mb-10"></div>
            <p className="text-gray-700 mb-12 text-lg leading-relaxed text-center">
              Hüpnoteraapia on tõhus meetod, mis võimaldab ligipääsu sinu alateadvusele – kohale, kus peituvad paljud sügavad uskumused ja mõttemustrid, mis võivad sind tagasi hoida. Tihti mõjutavad meid just need alateadlikud mustrid, mida me teadlikult ei märka, kuid mis mõjutavad meie otsuseid, käitumist ja üldist heaolu. Hüpnoosi abil saame neid sügavalt juurdunud uskumusi uurida, mõista ja neid positiivsemateks ümber kujundada.
            </p>
            
            <div className="mb-16 bg-gradient-to-br from-kaija-sage to-kaija-light/70 p-8 rounded-lg shadow-sm">
              <h2 className="text-2xl font-medium mb-6 text-center">Hüpnoteraapia töötab kõige paremini olukordades, kus on vaja tegeleda:</h2>
              <div className="w-16 h-1 bg-kaija-slate/60 rounded-full mx-auto mb-8"></div>
              <ul className="space-y-4 max-w-2xl mx-auto">
                {[
                  "Piiravate uskumuste ja mustritega, mis takistavad enesearengut",
                  "Ärevuse, stressi ja pinge vähendamisega",
                  "Enesekindluse ja eneseväärtustunde suurendamisega",
                  "Harjumuste muutmisega (näiteks suitsetamisest loobumine või toitumisharjumuste muutmine)",
                  "Trauma järgselt tekkivate emotsionaalsete blokeeringutega",
                  "Elu kvaliteedi parandamisega, toetades üldist tasakaalu ja heaolu"
                ].map((item, index) => (
                  <li key={index} className="flex items-start bg-white/50 p-4 rounded-lg shadow-sm transition-all duration-300 hover:shadow-md">
                    <span className="mr-4 text-kaija-slate bg-kaija-sage/50 p-2 rounded-full">
                      <Check size={20} />
                    </span>
                    <span className="text-gray-700">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
            
            <div className="my-16 relative">
              <div className="absolute -inset-4 bg-gradient-to-tr from-kaija-sage to-kaija-light opacity-30 blur-lg rounded-lg"></div>
              <img 
                src="/images/20200630_201631-01-1024x707.jpeg" 
                alt="Hüpnoteraapia" 
                className="rounded-lg shadow-md w-full relative z-10"
              />
            </div>
            
            <div className="space-y-8 mb-12">
              <div>
                <h2 className="text-2xl font-medium mb-4 text-center">Mida oodata hüpnoteraapiast?</h2>
                <div className="w-16 h-1 bg-kaija-slate/60 rounded-full mx-auto mb-6"></div>
                <p className="text-gray-700 mb-6 leading-relaxed">
                  Hüpnoteraapia on lõdvestunud ja meeldiv protsess, kus oled täielikult teadlik ja kontrollid ise kõike, mis seansi ajal toimub. See ei ole unenäoline seisund, vaid sügav lõdvestus, mis aitab sul keskenduda alateadlikele protsessidele. Kõik muutused, mida läbi teeme, on sinu teadlikud valikud ning eesmärk on toetada sinu isiklikku arengut ja heaolu.
                </p>
              </div>
              
              <div className="bg-gradient-to-br from-kaija-sage to-kaija-light/70 p-8 rounded-lg shadow-sm">
                <p className="text-gray-700 mb-0 leading-relaxed">
                  Parimate tulemuste saavutamiseks soovitan kohtuda 4–6 korda. Iga seanss kestab umbes 75 minutit, kus kaardistame esmalt juurpõhjused ning seejärel töötame piiravate mõttemustrite muutmisega positiivseteks ja toetavateks. Iga sessiooni lõpus saad kaasa salvestuse, mida saad kuulata kodus, et kinnistada tehtud muutusi ja tugevdada nende mõju.
                </p>
              </div>
            </div>
            
            <p className="text-gray-700 mb-12 text-xl italic text-center font-light">
              Kui oled valmis muutma oma alateadlikke mustreid ja looma elus püsivaid positiivseid muutusi, siis võta minuga ühendust ja alustame teekonda koos!
            </p>
            
            <div className="flex justify-center">
              <Button asChild className="bg-kaija-slate hover:bg-opacity-90 text-white px-8 py-6 text-lg group transition-all duration-300">
                <Link to="/contact" className="flex items-center">
                  Võta ühendust <ArrowRight className="ml-2 h-5 w-5 transition-transform group-hover:translate-x-1" />
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </section>
      
      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-kaija-light to-kaija-sage/70 text-center">
        <div className="container-custom">
          <h2 className="text-2xl md:text-3xl font-medium mb-6">Alusta enda teekonda</h2>
          <p className="text-gray-700 mb-8 max-w-2xl mx-auto text-lg">
            Muuda oma elu juba täna ja vaata teekonda positiivsema pilguga.
          </p>
          <Button asChild className="bg-kaija-slate hover:bg-opacity-90 text-white px-8 py-6 text-lg group transition-all duration-300">
            <Link to="/contact" className="flex items-center">
              Võta ühendust <ArrowRight className="ml-2 h-5 w-5 transition-transform group-hover:translate-x-1" />
            </Link>
          </Button>
        </div>
      </section>
    </div>
  );
};

export default Hypnotherapy;
